import { NavLink, useLocation } from "react-router-dom";
import {
  FaHome,
  FaServicestack,
  FaInfoCircle,
  FaEnvelopeOpenText,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import ziplogyxLogo from "../assets/images/CEDCoatings-Logo.png";
import maskGroup from "../assets/images/NewProject.svg";
import React, { useState } from "react";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navItems = [
    { to: "/", label: "Home", icon: FaHome },
    { to: "/service", label: "Services", icon: FaServicestack },
    { to: "/about", label: "About", icon: FaInfoCircle },
    { to: "/contact", label: "Contact Us", icon: FaEnvelopeOpenText },
  ];

  return (
    <header className="w-full h-[113px] fixed top-0 left-0 z-50">
      <div
        className="w-full h-full"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0)), url(${maskGroup})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex items-center justify-between px-4 md:px-8 h-full max-w-[1440px] mx-auto">
          <a href="/">
            <img
              src={ziplogyxLogo}
              alt="Ziplogyx Logo"
              className="w-[250px] max-h-[86px] z-10"
            />
          </a>

          {/* Hamburger Icon */}
          <div
            className="md:hidden text-[#ad2624] text-3xl cursor-pointer z-50"
            onClick={toggleMenu}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-10">
              {navItems.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `flex items-center gap-2 text-center text-[20px] font-semibold leading-[43.07px] px-5 py-2 rounded-full transition-all duration-300 ease-in-out ${
                      isActive
                        ? "bg-[#ffffff33] text-[#ad2624] shadow-md scale-105"
                        : "text-[#333333] hover:bg-[#ffffff33] hover:text-[#ad2624] hover:scale-105 hover:shadow-md"
                    }`
                  }
                >
                  <Icon
                    size={20}
                    className={`transition-transform duration-500 ${
                      location.pathname === to ? "rotate-[360deg]" : ""
                    }`}
                  />
                  {label}
                </NavLink>
              ))}
            </div>
          </nav>

          {/* Mobile Nav */}
          {menuOpen && (
            <nav className="absolute top-[113px] left-0 w-full bg-white/80 backdrop-blur-md flex flex-col items-center py-6 gap-6 md:hidden z-40 shadow-lg">
              {navItems.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={closeMenu}
                  className="flex items-center gap-2 text-[20px] font-semibold text-[#333333] hover:text-[#ad2624] transition-all"
                >
                  <Icon
                    size={20}
                    className={`transition-transform duration-500 ${
                      location.pathname === to ? "rotate-[360deg]" : ""
                    }`}
                  />
                  {label}
                </NavLink>
              ))}
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};
